import type { TypeChatLastMessage } from '@/types/conversation/types.conversation.chat.channel';
import type { TypeChatMessage } from '@/types/conversation/types.conversation.chat.message';

const PREVIEW_MAX = 80;

const shorten = (text: string): string => {
    const line = text.replace(/\s+/g, ' ').trim();
    return line.length > PREVIEW_MAX ? `${line.slice(0, PREVIEW_MAX - 1).trimEnd()}…` : line;
};

export function chatLastMessageOf(message: TypeChatMessage): TypeChatLastMessage {
    const preview = message.kind === 'poll' ? message.poll?.question ?? ''
        : message.kind === 'contact' ? message.contact?.name ?? ''
            : message.text;
    return {
        id: message.id,
        authorId: message.authorId,
        kind: message.kind,
        preview: shorten(preview),
        files: Math.max(message.attachments.length, message.expectedFiles),
        at: message.at,
    };
}

export default chatLastMessageOf;
